/* eslint-disable */
import axios from 'axios';

const hartaClient = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_HARTA,
  timeout: 30000,
  auth: {
    username: process.env.REACT_APP_BACKEND_HARTA_USERNAME,
    password: process.env.REACT_APP_BACKEND_HARTA_PASSWORD
  }
});

const expositoClient = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_EXPOSITO,
  timeout: 30000,
  auth: {
    username: process.env.REACT_APP_BACKEND_EXPOSITO_USERNAME,
    password: process.env.REACT_APP_BACKEND_EXPOSITO_PASSWORD
  }
});

const diceClient = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_DICE,
  timeout: 30000,
  auth: {
    username: process.env.REACT_APP_BACKEND_DICE_USERNAME,
    password: process.env.REACT_APP_BACKEND_DICE_PASSWORD
  }
});

const expositoCorpusId = process.env.REACT_APP_CORPUS_ID;

const limitHartaFormulas = process.env.REACT_APP_LIMIT_FORMULAS || 100;

// TODO: refactorizar funciones del axios.all
export default {
  formulas: {
    getFormulaById: formulaId =>
      hartaClient
        .get(`/formulas/${formulaId}`)
        .then(res => res.data)
        .catch(err => console.log(err)),
    getFormulaByTexto: texto =>
      hartaClient
        .get(
          `/formulas?texto=${texto}&limit=${limitHartaFormulas}&eliminado=false`
        )
        .then(res =>{console.log(res); res.data.formulas}),
    getByFuncionDiscursiva: texto =>
      hartaClient
        .get(
          `/formulas/?funcionDiscursiva=${texto}&algunaFuncionDiscursiva=false&publicado=all&open=true&limit=${limitHartaFormulas}&offset=0&eliminado=false`
        )
        .then(res => res.data.formulas)
        .catch(err => console.log(err))
  },
  corpus: {
    getByLemma: (lemma, limit, offset) => {
      limit = limit ? limit : 10;
      offset = offset ? offset : 0;
      return expositoClient
        .get(
          `/corpora/${expositoCorpusId}/lemmas/${lemma}?limit=${limit}&offset=${offset}`
        )
        .then(res => res.data);
    },
    getByForma: (forma, limit, offset) => {
      limit = limit ? limit : 10;
      offset = offset ? offset : 0;
      return expositoClient
        .get(
          `/corpora/${expositoCorpusId}/formas/${forma}?limit=${limit}&offset=${offset}`
        )
        .then(res => res.data)
        .catch(err => console.log(err));
    },
    getByFormasCombinadas: (formasCombinadas, limit, offset) => {
      limit = limit ? limit : 10;
      offset = offset ? offset : 0;
      return expositoClient
        .get(
          `/corpora/${expositoCorpusId}/strings/${formasCombinadas}?limit=${limit}&offset=${offset}`
        )
        .then(res => res.data)
        .catch(err => console.log(err));
    }
  },
  search: {
    getResults: texto =>
      axios
        .all([
          hartaClient.get(
            `/formulas?texto=${texto}&limit=${limitHartaFormulas}&eliminado=false&tipoCorpus=Expertos`
          ),
          expositoClient.get(`/colocaciones/suggestions?base=${texto}`)
        ])
        .then(
          axios.spread((formulasResponse, colocacionesResponse) => {
            let result = {
              formulas: formulasResponse.data.formulas,
              colocaciones: colocacionesResponse.data,
              base: texto
            };
            return result;
          })
        )
        .catch(err => {
          console.log(err);
        })
  },
  statistics: {
    getStatistics: queryString =>
      hartaClient
        .get(`/frases/estadisticas?${queryString}`)
        .then(res => res)
        .catch(err => console.log(err))
  },
  colocaciones: {
    //obtiene el listado de colocaciones a partir de un lema
    getCategoriesByLema: lema =>
      diceClient
        .get(`/colocacionescolocativos/categories?lema=${lema}`)
        .then(res => res.data)
        .catch(err => console.log(err)),
    //obtiene el listado de ejemplos de una categoría determinada
    getExampleById: example_id =>
      diceClient
        .get(`/colocacionescolocativos/example?id=${example_id}`)
        .then(res => res.data)
        .catch(err => console.log(err)),
    //obtiene el listado de clasificaciones sintacticas de un lema
    getClasificacionByLema: lema =>
      diceClient
        .get(`/colocacionescolocativos/clasify?lema=${lema}`)
        .then(res => res.data)
        .catch(err => console.log(err)),
    //obtiene el listado de colocaciones según lema y clasificacion sintactica
    getCategoriaByClasificacion: (lema, id) =>
      diceClient
        .get(`/colocacionescolocativos/clasifyfromcategory?lema=${lema}&id=${id}`)
        .then(res => res.data)
        .catch(err => console.log(err)), 
    //obtiene una clasificación determinada
    getOneCategory: (lema, categoria, id, sintagma) =>
      diceClient
        .get(`/colocacionescolocativos/category?lema=${lema}&categoria=${categoria}&id=${id}&sintagma=${sintagma}`)
        .then(res => res.data)
        .catch(err => console.log(err)), 
    //obtiene el número de unidades léxicas
    getUnidadesLexicas: lema =>
      diceClient
        .get(`/colocacionescolocativos/totalunidadeslexicas?lema=${lema}`)
        .then(res => res.data)
        .catch(err => console.log(err)), 
    //obtiene el total de datos cuantitativos por colocación
    getDatosCuantitativos: (lema,colocativo,clasificacion) =>
    //getDatosCuantitativos: (lema,colocativo) =>
      diceClient
        .get(`/colocacionescolocativos/totaldatoscuantitativos?lema=${lema}&colocativo=${colocativo}&clasificacion=${clasificacion}`)
        //.get(`/colocacionescolocativos/totaldatoscuantitativos?lema=${lema}&colocativo=${colocativo}`)
        .then(res => res.data)
        .catch(err => console.log(err)), 
    //obtiene el total de textos de colocativos
    getTextosColocativos: (corpus) =>
      diceClient
        .get(`/colocacionescolocativos/totaltextoscolocativos?corpus=${corpus}`)
        .then(res => res.data)
        .catch(err => console.log(err))  
  }
};
